module.exports = __webpack_public_path__ + "img/logo_sosclick.4aa41d57.png";